import store from "@/store"
import {setCookie,getCookie,removeCookie} from '@/utils/yl-cookie'
import { defaultSettings } from '@/settings';
const tokenKey = defaultSettings.token.key || "token"

export function getToken() {
  return store.getters["user/token"] || getCookie(tokenKey)
}

export function setToken(token) {
  setCookie(tokenKey, token)
  return store.commit("user/setToken", token)
}

export function removeToken() {
  removeCookie(tokenKey)
  return store.dispatch("user/logout")
}

export function getUserInfo() {
  return store.getters["user/userInfo"];
}